import React, {useEffect , useState} from "react";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import axios from "axios";
import { API_URL } from "../../constent";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  BlockDes,
  BackTo,
  PreviewCard,
  ReactDataTable,
  Row,
  Col,
} from "../../components/Component";
import { Collapse, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { Button } from "reactstrap";


var userData = JSON.parse(localStorage.getItem('userData'));
var role = userData?.[0]?.role;


const Reminder = () => {

const [data, setData] = useState([]);
const [loading, setLoading] = useState(true);
const [activeTab , setActivetab] = useState(0);
const [smCategory, setSmCategory] = useState('0');

const [currentPage, setCurrentPage] = useState(1);
const [itemPerPage] = useState(100);
const [stage, setStage] = useState([]);
const [activeStage, setActiveStage] = useState(null);


const toggle = (tab) => {
if (activeTab !== tab) setActivetab(tab);
};

var userData = JSON.parse(localStorage.getItem('userData'));
var getuserid = userData?.[0]?.id;
var role = userData?.[0]?.role;

const deleteMainsheet = (id) => {
    const formdata = new FormData();
    formdata.append('id' , id);
    formdata.append('searchCategory' , smCategory);
    formdata.append('stage' , activeStage);

    axios.post( `${API_URL}delete_mainsheet`, formdata)
    .then((response)=>{ 
        console.log(response.data);
        if(response.data.status === 'success'){
            alert('Deleted Successfully');
            getreport(activeStage);
        }else{
            alert('Something went wrong');
        }
    }
    )
    .catch((error) => {
        console.error("There was an error deleting the data!", error);
    }
    );
}

const getreport = (id) => {

    const formdata = new FormData();

    if(smCategory === '0'){
        alert('Please Select Category');
        setActiveStage(null);
        return false;
    }
    formdata.append('stage' , id);
    formdata.append('searchCategory' , smCategory);
    // setLoading(true);

    axios.post( `${API_URL}getreport`, formdata)
    .then((response)=>{

        console.log(response.data);
        setData(response.data);
        // setLoading(false);
    })
}

useEffect(()=>{
  axios.get(`${API_URL}getmainsheet_desh/${getuserid}`).then((result)=>
  {
    setStage(result.data);
      setLoading(false);
  })
 },[])


 const indexOfLastItem = currentPage * itemPerPage;
 const indexOfFirstItem = indexOfLastItem - itemPerPage;
 const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
 const paginate = (pageNumber) => setCurrentPage(pageNumber);

 if (loading) {
    return(
       <>
         <p>Loading....</p>
       </>
    ) 
} 


  return (
    <React.Fragment>
      <Head title="Reminder List"/>
      <Content>
        <BlockHead size="sm">
        <Row className="g-gs top_head_css">
                <Col sm="3">
                     <p>Reminder</p>
                </Col>
                <Col sm="3">
                    <div className="input_bg_css">
                        <select
                            className="form-select form-control"
                            onChange={(e) => {
                              setSmCategory(e.target.value);
                            }}
                            value={smCategory}
                        >
                            <option value="0">Select Category</option>
                            <option value="1">HEALTH</option>
                            <option value="4">MOTOR</option>
                            <option value="10">NON MOTOR</option>
                        </select>
                    </div>
                </Col>
          </Row>
        </BlockHead>
        <Block size="lg">

        <Row className="g-gs rimnder_row">
        
        {stage.length > 0 ? (
              stage.map((item, index) => {
                return (
                  <Col md="4" key={index}>
                    <div className={`reminder_card ${activeStage === item.id ? 'active' : ''}`}  onClick={() => {
                            setActiveStage(item.id);
                            getreport(item.id);
                          }} > 
                       {item.label}
                    </div>
                  </Col>
                );
              })) : (
              <p>No Data Found</p>
            )}
        
        </Row>

        </Block>

        <Block>
                <div className="card">
                {
                  smCategory === '1' ? (
                    currentItems.length > 0 ? (
                <div className="table-responsive card-inner">
                        <table className="table table-bordered table-striped">
                            <thead>
                            <tr>
                                <th>PROPOSER</th>
                                <th>ADDRESS OF CORRESPONDENCE</th>
                                <th>POLICY ADDRESS</th>
                                <th>AADHAR NUMBER</th>
                                <th>PAN NUMBER</th>
                                <th>EMAIL ID</th>
                                <th>MOBILE NUMBER</th>
                                <th>WHATSAPP NUMBER</th>
                                <th>DATE OF BIRTH</th>
                                <th>TYPE OF POLICY</th>
                                <th>NAME OF PRODUCT</th>
                                <th>RIDERS</th>
                                <th>DETAILS OF INSURED</th>
                                <th>ANNUAL INCOME</th>
                                <th>SUM INSURED</th>
                                <th>BONUS</th>
                                <th>ADDITIONAL BONUS</th>
                                <th>DEDUCTIBLE</th>
                                <th>FLOATER/INDIVIDUAL</th>
                                <th>PRE EXISTING</th>
                                <th>INSURED SINCE</th>
                                <th>MOROTORIAM PERIOD</th>
                                <th>POLICY START DATE</th>
                                <th>POLICY END DATE</th>
                                <th>PREVIOUS POLICY NUMBER</th>
                                <th>NAME OF INSURER</th>
                                <th>CURRENT POLICY NUMBER</th>
                                <th>NAME OF INSURER</th>
                                <th>NET PREMIUM</th>
                                <th>LOADING</th>
                                <th>GST</th>
                                <th>TOTAL PREMIUM</th>
                                <th>NOMINEE DETAILS</th>
                                <th>NOTES</th>
                                <th>DOCS</th>
                                <th>ACTION</th>
                            </tr>
                            </thead>
                            <tbody>
                            {currentItems.length > 0
                                ? currentItems.map((item) => (
                                    <tr key={item.id}>
                                    <td>{item.proposer}</td>
                                    <td>{item.address}</td>
                                    <td>{item.policy_address}</td>
                                    <td>{item.aadhar_number}</td>
                                    <td>{item.pan_number}</td>
                                    <td>{item.email_id}</td>
                                    <td>{item.phone_number}</td>
                                    <td>{item.whatsapp_number}</td>
                                    <td>{item.dob}</td>
                                    <td>{item.type_policy}</td>
                                    <td>{item.product}</td>
                                    <td>{item.riders}</td>
                                    <td>{item.details_insured}</td>
                                    <td>{item.annual_income}</td>
                                    <td>{item.sum_insured}</td>
                                    <td>{item.bonus}</td>
                                    <td>{item.add_bonus}</td>
                                    <td>{item.deductible}</td>
                                    <td>{item.floater}</td>
                                    <td>{item.pre_exixting}</td>
                                    <td>{item.insured_since}</td>
                                    <td>{item.moto_preiod}</td>
                                    <td>{item.policy_start_date}</td>
                                    <td>{item.policy_end_date}</td>
                                    <td>{item.current_policy_no}</td>
                                    <td>{item.current_policy_insurer}</td>
                                    <td>{item.pre_policy_no}</td>
                                    <td>{item.pre_policy_insurer}</td>
                                    <td>{item.net_premium}</td>
                                    <td>{item.loading}</td>
                                    <td>{item.gst}</td>
                                    <td>{item.total_premium}</td>
                                    <td>{item.nominee}</td>
                                    <td>{item.note}</td>
                                    <td>
                                      {Array.isArray(item.docs) ? (
                                        item.docs.map((doc, index) => (
                                          <a href={doc} key={index} className="btn btn-sm btn-warning" style={{ marginBottom: "10px" }} target="_blank" rel="noopener noreferrer">
                                            View
                                          </a>
                                        ))
                                      ) : item.docs !== null && item.docs !== "" ? (
                                        <a href={item.docs} className="btn btn-sm btn-warning" style={{ marginBottom: "10px" }} target="_blank" rel="noopener noreferrer">
                                          View
                                        </a>
                                      ) : (
                                        <span>No Document</span>
                                      )}
                                    </td>
                                    <td>
                                      <Button className="btn btn-sm" color="primary" onClick={() => deleteMainsheet(item.id)}>
                                        Delete
                                      </Button>
                                    </td>
                                    </tr>
                                ))
                                : (
                                <tr>
                                    <td colSpan="13" className="text-center">
                                    No data available
                                    </td>
                                </tr>
                                )}
                            </tbody>
                        </table>
                        </div>
                        ):(
                            <div className="text-center">
                            <p>No Data Found</p>
                            </div>
                        )):(
                          null
                        )}
        
           {
                  smCategory === '4' ? (
                    currentItems.length > 0 ? (
                <div className="table-responsive card-inner">
                        <table className="table table-bordered table-striped">
                            <thead>
                            <tr>
                                <th>PROPOSER</th>
                                <th>ADDRESS OF CORRESPONDENCE</th>
                                <th>POLICY ADDRESS</th>
                                <th>EMAIL ID</th>
                                <th>MOBILE NUMBER</th>
                                <th>WHATSAPP NUMBER</th>
                                <th>AADHAR NUMBER</th>
                                <th>PAN NUMBER</th>
                                <th>VEHICLE REGISTRATION  NUMBER</th>
                                <th>MAKE</th>
                                <th>CHASIS NUMBER</th>
                                <th>ENGINE NUMBER</th>
                                <th>REGISTRATION VALIDITY DATE</th>
                                <th>CUBIC CAPACITY</th>
        
                                <th>YEAR OF MANUFACTURE</th>
                                <th>COLOR</th>
                                <th>SEATING CAPACITY</th>
                                <th>GSTIN</th>
                                <th>FUEL TYPE</th>
                                <th>PREVIOUS POLICY NUMBER</th>
                                <th>NAME OF INSURER</th>
                                <th>CURRENT POLICY NUMBER</th>
                                <th>NAME OF INSURER</th>
                                <th>POLICY STATUS</th>
                                <th>DOCS</th>
                                <th>ACTION</th>
                            </tr>
                            </thead>
                            <tbody>
                            {currentItems.length > 0
                                ? currentItems.map((item) => (
                                    <tr key={item.id}>
                                    <td>{item.proposer}</td>
                                    <td>{item.address}</td>
                                    <td>{item.policy_address}</td>
                                    <td>{item.email_id}</td>
                                    <td>{item.phone_number}</td>
                                    <td>{item.whatsapp_number}</td>
                                    <td>{item.aadhar_number}</td>
                                    <td>{item.pan_number}</td>
                                    <td>{item.vehicle_reg_number}</td>
                                    <td>{item.make}</td>
                                    <td>{item.chasis_number}</td>
                                    <td>{item.engine_number}</td>
                                    <td>{item.reg_validity_date}</td>
                                    <td>{item.cubic_capacity}</td>
                                    <td>{item.year_manuf}</td>
                                    <td>{item.color}</td>
                                    <td>{item.seating_capacity}</td>
                                    <td>{item.gstin}</td>
                                    <td>{item.fuel_type}</td>
                                    <td>{item.current_policy_no}</td>
                                    <td>{item.current_policy_insurer}</td>
                                    <td>{item.pre_policy_no}</td>
                                    <td>{item.pre_policy_insurer}</td>
                                    <td>{item.policy_status === '1' ? (
                                        <div>ACTIVE</div>
                                        ) : item.policy_status === '2' ? (
                                        <div>NEW INACTIVE</div>
                                        ) : item.policy_status === '3' ? (
                                          <div>CANCELLED</div>
                                        ):(
                                         <div>EXPIRED</div>
                                        )}</td>

                                      <td>
                                      {Array.isArray(item.docs) ? (
                                        item.docs.map((doc, index) => (
                                          <a href={doc} key={index} className="btn btn-sm btn-warning" style={{ marginBottom: "10px" }} target="_blank" rel="noopener noreferrer">
                                            View
                                          </a>
                                        ))
                                      ) : item.docs !== null && item.docs !== "" ? (
                                        <a href={item.docs} className="btn btn-sm btn-warning" style={{ marginBottom: "10px" }} target="_blank" rel="noopener noreferrer">
                                          View
                                        </a>
                                      ) : (
                                        <span>No Document</span>
                                      )}
                                      </td>
        
                                        <td>
                                          <Button className="btn btn-sm" color="primary" onClick={() => deleteMainsheet(item.id)}>
                                            Delete
                                          </Button>
                                        </td>
                                        
                                    </tr>
                                ))
                                : (
                                <tr>
                                    <td colSpan="13" className="text-center">
                                    No data available
                                    </td>
                                </tr>
                                )}
                            </tbody>
                        </table>
                        </div>
                        ):(
                          <div className="text-center">
                            <p>No Data Found</p>
                          </div>
                        )):(
                          null
                        )}
        
        {
                  smCategory === '10' ? (
                    currentItems.length > 0 ? (
                <div className="table-responsive card-inner">
                        <table className="table table-bordered table-striped">
                            <thead>
                            <tr>
                                <th>PROPOSER</th>
                                <th>ADDRESS OF CORRESPONDENCE</th>
                                <th>POLICY ADDRESS</th>
                                <th>RISK LOCATION ADDRESS</th>
                                <th>EMAIL ID</th>
                                <th>MOBILE NUMBER</th>
                                <th>WHATSAPP NUMBER</th>
                                <th>GSTIN NUMBER</th>
                                <th>AADHAR NUMBER</th>
                                <th>PAN NUMBER</th>
                                <th>TYPE OF POLICY</th>
                                <th>COVERAGE</th>
                                <th>FIRE TARIFF CODE</th>
                                <th>RISK CATEGORY (AS PER THE TARIFF CODE)</th>
                                <th>SUM INSURED</th>
                                <th>SUM INSURED BREAKUP</th>
                                <th>NET PREMIUM</th>
                                <th>GST</th>
                                <th>TOTAL PREMIUM</th>
                                <th>POLICY START DATE</th>
                                <th>POLICY END DATE</th>
                                <th>PREVIOUS POLICY NUMBER</th>
                                <th>NAME OF INSURER</th>
                                <th>CURRENT POLICY NUMBER</th>
                                <th>NAME OF INSURER</th>
                                <th>AGENT</th>
                                <th>MODE OF PAYMENT</th>
                                <th>PAYMENT DETAILS</th>
                                <th>STATUS OF POLICY</th>
                                <th>NOMINEE DETAILS</th>
                                <th>NOTES</th>
                                <th>DOCS</th>
                                <th>ACTION</th>
                            </tr>
                            </thead>
                            <tbody>
                            {currentItems.length > 0
                                ? currentItems.map((item) => (
                                    <tr key={item.id}>
                                    <td>{item.proposer}</td>
                                    <td>{item.address}</td>
                                    <td>{item.policy_address}</td>
                                    <td>{item.risk_location_address}</td>
                                    <td>{item.email_id}</td>
                                    <td>{item.phone_number}</td>
                                    <td>{item.whatsapp_number}</td>
                                    <td>{item.aadhar_number}</td>
                                    <td>{item.pan_number}</td>
                                    <td>{item.gst_number}</td>
                                    <td>{item.type_policy}</td>
                                    <td>{item.coverage}</td>
                                    <td>{item.fire_trf_code}</td>
                                    <td>{item.risk_code}</td>
                                    <td>{item.sum_insured}</td>
                                    <td>{item.sum_insured_breakup}</td>
                                    <td>{item.net_premium}</td>
                                    <td>{item.gst}</td>
                                    <td>{item.total_premium}</td>
                                    <td>{item.policy_start_date}</td>
                                    <td>{item.policy_end_date}</td>
                                    <td>{item.pre_policy_no}</td>
                                    <td>{item.pre_policy_insurer}</td>
                                    <td>{item.current_policy_no}</td>
                                    <td>{item.current_policy_insurer}</td>
                                    <td>{item.agent}</td>
                                    <td>{item.mode_of_payment}</td>
                                    <td>{item.payment_details}</td>
                                    <td>{item.policy_status === '1' ? (
                                        <div>ACTIVE</div>
                                        ) : item.policy_status === '2' ? (
                                        <div>NEW INACTIVE</div>
                                        ) : item.policy_status === '3' ? (
                                          <div>CANCELLED</div>
                                        ):(
                                         <div>EXPIRED</div>
                                        )}</td>
                                    
                                    <td>{item.nominee}</td>
                                    <td>{item.note}</td>  
                                    <td>
                                      {Array.isArray(item.docs) ? (
                                        item.docs.map((doc, index) => (
                                          <a href={doc} key={index} className="btn btn-sm btn-warning" style={{ marginBottom: "10px" }} target="_blank" rel="noopener noreferrer">
                                            View
                                          </a>
                                        ))
                                      ) : item.docs !== null && item.docs !== "" ? (
                                        <a href={item.docs} className="btn btn-sm btn-warning" style={{ marginBottom: "10px" }} target="_blank" rel="noopener noreferrer">
                                          View
                                        </a>
                                      ) : (
                                        <span>No Document</span>
                                      )}
                                    </td>    
                                    <td>
                                      <Button className="btn btn-sm" color="primary" onClick={() => deleteMainsheet(item.id)}>
                                        Delete
                                      </Button>
                                    </td>
                                    </tr>
                                ))
                                : (
                                <tr>
                                    <td colSpan="13" className="text-center">
                                    No data available
                                    </td>
                                </tr>
                                )}
                            </tbody>
                        </table>
                        </div>
                        ):(
                          <div className="text-center">
                            <p>No Data Found</p>
                          </div>
                        )):(
                          null
                        )}
        
        
                    </div>
                </Block>


      </Content>
    </React.Fragment>
  );
};
export default Reminder;
